import React from 'react'
import TextCard from '~/components/molecules/TextCard'
import PricingForm2 from '~/components/organisms/PrincingForm2'
import FadeInWhenVisible from '~/components/FadeInWhenVisible'

export default function HeroPricing2({key, index, postcodeParameter, ...props}) {

  const section = props.heroPricing

  return (
    <section id={section.fieldGroupName + index} className="mb-24 md:mb-40 py-40 pb-20 md:pb-8 bg-sand relative">
      <div className="container">
        <div className="grid grid-cols-12">
          <div className="col-span-12 md:col-span-5 mb-10 grid md:grid-cols-5 h-full items-center">
            <TextCard className="text-center col-span-5 " {...section.textCard} />
          </div>
          <FadeInWhenVisible className="col-span-12 md:col-span-6 md:col-start-7 -mb-32">
            <PricingForm2 className="bg-white border border-[#EFEEEA]" postcodeParameter={postcodeParameter} />
          </FadeInWhenVisible>
        </div>
      </div>
    </section>
  )
}
